import classNames from 'classnames';
import { map } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import SizeButton from 'components/SizeButton';
import { mediumUp } from 'constants/mediaQueries';
import { TYPES } from 'constants/merchandising';
import Theme from 'styles/theme';
import Size from 'utils/Size';

const MAX_SIZES_PER_ROW_MOBILE = 7;
const MAX_SIZES_PER_ROW_DESKTOP = 7;
const MAX_SIZES_PER_ROW_DESKTOP_STORYTELLING = 8;

const Grid = ({ sizes, selectSize, currentSize, type, pdpStorytellingEnabled }) => (
  <ul className="PdpSizeSelector__grid">
    {map(sizes, ({ id, value, available, handle }) => {
      const isActive = currentSize === handle;

      return (
        <li
          className={classNames('PdpSizeSelector__grid-item', {
            'PdpSizeSelector__grid-item--two-column': type === TYPES.SOCKS,
            'PdpSizeSelector__grid-item--three-column':
              type !== TYPES.SOCKS && !Size.isSizeButtonSquare(value),
          })}
          key={id}
        >
          <SizeButton
            label={value}
            available={available}
            active={isActive}
            onClick={() => selectSize(isActive ? null : handle)}
          />
        </li>
      );
    })}
    <style jsx>
      {`
        .PdpSizeSelector__grid {
          padding: 0;
          margin: 0 ${Theme.get('spacing') / -2}px;
        }

        .PdpSizeSelector__grid-item {
          display: inline-block;
          width: ${100 / MAX_SIZES_PER_ROW_MOBILE}%;
          max-width: 65px;
          padding: 0 ${Theme.get('spacing') / 2}px ${Theme.get('spacing')}px;
          margin: 0;
        }

        @media ${mediumUp} {
          .PdpSizeSelector__grid-item {
            width: ${pdpStorytellingEnabled
              ? 100 / MAX_SIZES_PER_ROW_DESKTOP_STORYTELLING
              : 100 / MAX_SIZES_PER_ROW_DESKTOP}%;
          }
        }

        .PdpSizeSelector__grid-item--two-column {
          width: 50%;
        }

        .PdpSizeSelector__grid-item--three-column {
          width: 33.333%;
        }
      `}
    </style>
  </ul>
);

Grid.propTypes = {
  sizes: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      value: PropTypes.string.isRequired,
      available: PropTypes.bool.isRequired,
      handle: PropTypes.string.isRequired,
    })
  ).isRequired,
  selectSize: PropTypes.func.isRequired,
  currentSize: PropTypes.string,
  type: PropTypes.string.isRequired,
  pdpStorytellingEnabled: PropTypes.bool,
};

Grid.defaultProps = { currentSize: null };

export default Grid;
